import { createUpdateMessage } from './update-message';
const updateSuccess = createUpdateMessage('Success');
/**
 * Returns a function to add a global success message.
 *
 * Emits a native browser event, keeping this package free of any dependency on redux
 * or the rest of the Famly app.
 *
 * @returns a function to add success messages to the global status bar without any dependencies
 * to the rest of the Famly app
 */
export function useUpdateSuccess() {
    return updateSuccess;
}
